/** Subject-neutral, seekable reveal engine. All state is derived from media time. */
export type TeachingStep = { id: string; text: string; caption: string; startMs: number; endMs: number };
export type TeachingPlan = { steps: TeachingStep[]; durationMs: number };
export function stepProgress(step: TeachingStep, positionMs: number, reduced = false): number {
  if (!Number.isFinite(positionMs) || positionMs < step.startMs) return 0;
  if (reduced || step.endMs <= step.startMs) return 1;
  return Math.max(0, Math.min(1, (positionMs - step.startMs) / (step.endMs - step.startMs)));
}
